import "./App.css";
import React from "react";
import {Navigate, Route, Routes} from "react-router-dom";
import Login from "./components/Login";
import PrivateRoute from "./components/PrivateRoute";
import PriceDeviationHistogramInternal from "./components/PriceDeviationHistogramInternal";
import Notifications from "./components/Notifications";
import MarketData from "./components/MarketData";

const App = () => {
    return (
        <div className="App">
            <Routes>
                <Route path="/login" element={<Login />} />
                <Route
                    path="/"
                    element={
                        <PrivateRoute>
                            <PriceDeviationHistogramInternal />
                        </PrivateRoute>
                    }
                />
                <Route
                    path="/pricehistogram"
                    element={
                        <PrivateRoute>
                            <PriceDeviationHistogramInternal />
                        </PrivateRoute>
                    }
                />
                <Route
                    path="/notifications"
                    element={
                        <PrivateRoute>
                            <Notifications />
                        </PrivateRoute>
                    }
                />
                <Route
                    path="/marketdata"
                    element={
                        <PrivateRoute>
                            <MarketData />
                        </PrivateRoute>
                    }
                />
                <Route path="*" element={<Navigate to="/" />} />
            </Routes>
        </div>
    );
};
export default App;
